import get from 'lodash.get';

const getLanguageSelectorItems = (legacyLocalisations)=>{
    const translations = get(legacyLocalisations, 'translations', []);
    if (!translations.length) {
        return [];
    }
    return translations.map((locale)=>{
        const isValidLocale = !!locale.localeLabel && !!locale.url;
        if (!isValidLocale) {
            return null;
        }
        return {
            label: get(locale, 'localeLabel', ''),
            locale: get(locale, 'locale', ''),
            href: get(locale, 'url', '')
        };
    }).filter(Boolean);
};

export { getLanguageSelectorItems };
